import {Layer} from "@luciad/ria/view/Layer";
import React from "react";
import "./LayerSelectionPanel.css";

interface Props {
  editable: boolean;
  layers: Layer[];
  selectedLayers: Layer[];
  onSelectionChange: (layer: Layer, selected: boolean) => void;
  textLeft?: boolean;
}

export const LayerSelectionPanel = ({
                                      editable,
                                      layers,
                                      selectedLayers,
                                      onSelectionChange,
                                      textLeft = true,
                                    }: Props) => {
  if (editable) {
    return (
        <LayerSelectionEditingPanel
            layers={layers}
            selectedLayers={selectedLayers}
            onSelectionChange={onSelectionChange}
            textLeft={textLeft}
        />
    );
  } else {
    return <SelectedLayersPanel layers={selectedLayers}/>;
  }
};

interface LayerSelectionEditingProps {
  layers: Layer[];
  selectedLayers: Layer[];
  onSelectionChange: (layer: Layer, selected: boolean) => void;
  textLeft?: boolean;
}

export const LayerSelectionEditingPanel = ({
                                             layers,
                                             selectedLayers,
                                             onSelectionChange,
                                             textLeft = true,
                                           }: LayerSelectionEditingProps) => {
  return (
      <div className="layer-selection-panel">
        {layers.map(layer => {
          const selected = selectedLayers.indexOf(layer) >= 0;
          return (
              <label
                  key={layer.id}
                  className={
                    "layer-selection-label " + (textLeft ? "text-left" : "text-right")
                  }
                  onClick={event => {
                    onSelectionChange(layer, !selected);
                    event.stopPropagation();
                  }}
              >
                {textLeft && layer.label}
                <span className={"layer-selection-checkbox"}>
              {selected ? "✓" : "□"}
            </span>
                {!textLeft && layer.label}
              </label>
          );
        })}
      </div>
  );
};

interface SelectedLayersProps {
  layers: Layer[];
  textLeft?: boolean;
}

const SelectedLayersPanel = ({layers, textLeft = true}: SelectedLayersProps) => {
  return (
      <div className="layer-selection-panel">
        {layers.map(layer => (
            <label className={"selected-layer-label " + (textLeft ? "text-left" : "text-right")} key={layer.id}>
              {layer.label}
            </label>
        ))}
        {layers.length === 0 && (
            <label className={"selected-layer-label " + (textLeft ? "text-left" : "text-right")} key="no layers">
              No layers selected
            </label>
        )}
      </div>
  );
};
